// import React, { useState, useEffect, useRef } from "react";
// import { FiSearch, FiX } from "react-icons/fi";

// const SearchOverlay = ({ isOpen, onClose }) => {
//     const [query, setQuery] = useState("");
//     const [results, setResults] = useState([]);
//     const inputRef = useRef(null);

//     // Auto-focus input when opened
//     useEffect(() => {
//         if (isOpen && inputRef.current) {
//             setTimeout(() => inputRef.current.focus(), 200);
//         }
//     }, [isOpen]);

//     // Close on ESC
//     useEffect(() => {
//         const keyHandler = (e) => e.key === "Escape" && onClose();
//         window.addEventListener("keydown", keyHandler);
//         return () => window.removeEventListener("keydown", keyHandler);
//     }, [onClose]);

//     // Fetch from Strapi API
//     const fetchResults = async (searchText) => {
//         if (!searchText || searchText.trim() === "") {
//             setResults([]);
//             return;
//         }

//         try {
//             // Fetch posts & publications at the same time
//             const postsReq = fetch(
//                 `${process.env.REACT_APP_STRAPI_URL}/api/posts?filters[$or][0][title][$containsi]=${searchText}&filters[$or][1][description][$containsi]=${searchText}&pagination[limit]=10`
//             );

//             const publicationsReq = fetch(
//                 `${process.env.REACT_APP_STRAPI_URL}/api/publications?filters[$or][0][title][$containsi]=${searchText}&filters[$or][1][description][$containsi]=${searchText}&pagination[limit]=10`
//             );

//             const [postsRes, publicationsRes] = await Promise.all([
//                 postsReq,
//                 publicationsReq,
//             ]);

//             const postsData = (await postsRes.json()).data || [];
//             const publicationsData = (await publicationsRes.json()).data || [];

//             console.log(postsData)
//             console.log(publicationsData)
//             // Combine, clean & normalize safely
//             const combined = [...postsData, ...publicationsData]
//                 .map((item) => {
//                     const attrs = item?.attributes || {};

//                     // Auto-detect possible title fields safely
//                     const title =
//                         attrs.title ||
//                         attrs.description ||
//                         attrs.heading ||
//                         attrs.slug ||
//                         "Başlıksız";

//                     // Auto-detect slug
//                     const slug = attrs.slug || attrs.Slug || null;

//                     // Determine type
//                     const type = slug ? "Post" : "Publication";

//                     return {
//                         id: item.id,
//                         title,
//                         type,
//                         url: slug
//                             ? `/basin/yayinlar/${slug}`
//                             : `/basin/haberler/${slug}`,
//                     };
//                 })
//                 .slice(0, 10); // final limit

//             setResults(combined);
//         } catch (err) {
//             console.log("Search error:", err);
//         }
//     };

//     // Handle typing
//     const handleChange = (e) => {
//         const value = e.target.value;
//         setQuery(value);
//         fetchResults(value);
//     };

//     if (!isOpen) return null;

//     return (
//         <div
//             className="fixed inset-0 z-[9999] bg-black/60 backdrop-blur-md flex items-start justify-center pt-[10vh] animate-fadeIn"
//             onClick={onClose}
//         >
//             {/* Wrapper */}
//             <div
//                 className="bg-white w-full max-w-2xl mx-6 rounded-xl shadow-xl p-6 animate-slideDown"
//                 onClick={(e) => e.stopPropagation()}
//             >
//                 {/* Search Header */}
//                 <div className="flex items-center gap-3 border-b pb-3">
//                     <FiSearch className="text-gray-500 text-xl" />
//                     <input
//                         ref={inputRef}
//                         type="text"
//                         className="w-full bg-transparent outline-none text-lg placeholder-gray-400"
//                         placeholder="Aramak istediğinizi yazın..."
//                         value={query}
//                         onChange={handleChange}
//                     />
//                     <button onClick={onClose}>
//                         <FiX className="text-gray-600 hover:text-black text-2xl" />
//                     </button>
//                 </div>

//                 {/* Results */}
//                 <div className="mt-4 space-y-2 max-h-[50vh] overflow-y-auto">
//                     {results.length === 0 && query.length > 0 && (
//                         <p className="text-gray-500 text-center py-4">Sonuç bulunamadı.</p>
//                     )}

//                     {results.map((item) => (
//                         <a
//                             key={item.id}
//                             href={item.url}
//                             className="block p-3 rounded-lg border hover:bg-gray-50 transition-all"
//                         >
//                             <div className="flex justify-between items-center">
//                                 <p className="font-medium text-gray-900">{item.title}</p>
//                                 <span className="text-xs px-2 py-1 bg-blue-100 text-blue-700 rounded">
//                                     {item.type}
//                                 </span>
//                             </div>
//                         </a>
//                     ))}
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default SearchOverlay;





// import React, { useState, useEffect, useRef, useCallback } from "react";
// import { FiSearch, FiX, FiFile, FiFileText } from "react-icons/fi";
// import ReactMarkdown from 'react-markdown';
// import { STRAPI_URL } from "../../../config/constants";
// const SearchOverlay = ({ isOpen, onClose }) => {
//     const [query, setQuery] = useState("");
//     const [results, setResults] = useState([]);
//     const [isLoading, setIsLoading] = useState(false);
//     const [error, setError] = useState(null);
//     const inputRef = useRef(null);
//     const debounceTimerRef = useRef(null);

//     // Auto-focus input when opened
//     useEffect(() => {
//         if (isOpen && inputRef.current) {
//             setTimeout(() => inputRef.current.focus(), 100);
//         }
//     }, [isOpen]);

//     // Close on ESC key
//     useEffect(() => {
//         const handleKeyDown = (e) => {
//             if (e.key === "Escape") {
//                 onClose();
//             }
//         };

//         if (isOpen) {
//             window.addEventListener("keydown", handleKeyDown);
//             return () => window.removeEventListener("keydown", handleKeyDown);
//         }
//     }, [isOpen, onClose]);

//     // Reset state when overlay closes
//     useEffect(() => {
//         if (!isOpen) {
//             setQuery("");
//             setResults([]);
//             setError(null);
//         }
//     }, [isOpen]);

//     // Normalize item structure
//     const normalizeItem = (item, type, basePath) => {
//         // console.log("Normalizing item:", item);

//         if (!item) {
//             //console.log("Item is null/undefined");
//             return null;
//         }

//         // Handle both direct attributes and nested attributes
//         const attrs = item.attributes || item;
//         //console.log("Attributes:", attrs);

//         const title = attrs.title || attrs.description || attrs.heading || attrs.name || "Başlıksız";
//         const slug = attrs.slug || attrs.Slug || item.id;
//         const description = attrs.description || attrs.excerpt || attrs.summary || "";

//         //console.log("Extracted - title:", title, "slug:", slug);

//         const normalized = {
//             id: `${type}-${item.id}`,
//             title: title.length > 100 ? `${title.substring(0, 100)}...` : title,
//             description: description.length > 150 ? `${description.substring(0, 150)}...` : description,
//             type,
//             url: `${basePath}/${slug}`,
//             slug
//         };

//         //console.log("Normalized item:", normalized);
//         return normalized;
//     };

//     // Fetch results from Strapi API
//     const fetchResults = useCallback(async (searchText) => {
//         if (!searchText || searchText.trim().length < 2) {
//             setResults([]);
//             setIsLoading(false);
//             return;
//         }

//         setIsLoading(true);
//         setError(null);

//         try {
//             const baseUrl = STRAPI_URL || "http://localhost:1337";
//             // const trimmedSearch = encodeURIComponent(searchText.trim());

//             const cleaned = searchText
//                 .replace(/[^a-zA-Z0-9\s]/g, '')   // remove special chars
//                 .replace(/\s+/g, ' ')             // collapse spaces
//                 .trim();

//             const trimmedSearch = encodeURIComponent(cleaned);


//             // Build URLs with proper Strapi filter syntax
//             const postsUrl = `${baseUrl}/api/posts?filters[$or][0][title][$containsi]=${trimmedSearch}&filters[$or][1][description][$containsi]=${trimmedSearch}&pagination[limit]=10&populate=*`;

//             const publicationsUrl = `${baseUrl}/api/publications?filters[$or][0][title][$containsi]=${trimmedSearch}&filters[$or][1][description][$containsi]=${trimmedSearch}&pagination[limit]=10&populate=*`;

//             //console.log("Fetching posts from:", postsUrl);
//             //console.log("Fetching publications from:", publicationsUrl);

//             // Fetch both endpoints in parallel
//             const [postsResponse, publicationsResponse] = await Promise.all([
//                 fetch(postsUrl),
//                 fetch(publicationsUrl)
//             ]);

//             //console.log("Posts response status:", postsResponse.status);
//             //console.log("Publications response status:", publicationsResponse.status);

//             if (!postsResponse.ok || !publicationsResponse.ok) {
//                 throw new Error(`API request failed: Posts ${postsResponse.status}, Publications ${publicationsResponse.status}`);
//             }

//             const postsJson = await postsResponse.json();
//             const publicationsJson = await publicationsResponse.json();

//             //console.log("Posts data:", postsJson);
//             //console.log("Publications data:", publicationsJson);

//             const postsData = postsJson.data || [];
//             const publicationsData = publicationsJson.data || [];

//             //console.log(`Found ${postsData.length} posts and ${publicationsData.length} publications`);

//             // Process and combine results
//             const processedResults = [
//                 ...postsData.map(item => normalizeItem(item, "Post", "/basin/haberler")),
//                 ...publicationsData.map(item => normalizeItem(item, "Publication", "/basin/yayinlar"))
//             ]
//                 .filter(item => item !== null)
//                 .slice(0, 10);

//             //console.log("Processed results:", processedResults);

//             setResults(processedResults);
//         } catch (err) {
//             //console.error("Search error:", err);
//             setError("Arama sırasında bir hata oluştu. Lütfen tekrar deneyin.");
//             setResults([]);
//         } finally {
//             setIsLoading(false);
//         }
//     }, []);

//     // Debounced search handler
//     const handleInputChange = (e) => {
//         const value = e.target.value;
//         setQuery(value);

//         // Clear previous timer
//         if (debounceTimerRef.current) {
//             clearTimeout(debounceTimerRef.current);
//         }

//         // Set new timer for debounced search
//         debounceTimerRef.current = setTimeout(() => {
//             fetchResults(value);
//         }, 300);
//     };

//     // Clear search
//     const handleClear = () => {
//         setQuery("");
//         setResults([]);
//         setError(null);
//         if (inputRef.current) {
//             inputRef.current.focus();
//         }
//     };

//     if (!isOpen) return null;

//     return (
//         <div
//             className="fixed inset-0 z-[9999] bg-black/60 backdrop-blur-sm flex items-start justify-center pt-[10vh] transition-opacity duration-200"
//             onClick={onClose}
//         >
//             {/* Search Container */}
//             <div
//                 className="bg-white w-full max-w-2xl mx-4 rounded-xl shadow-2xl overflow-hidden transform transition-all duration-300"
//                 onClick={(e) => e.stopPropagation()}
//             >
//                 {/* Search Header */}
//                 <div className="flex items-center gap-3 p-4 border-b border-gray-200">
//                     <FiSearch className="text-gray-400 text-xl flex-shrink-0" />
//                     <input
//                         ref={inputRef}
//                         type="text"
//                         className="flex-1 bg-transparent outline-none text-lg placeholder-gray-400"
//                         placeholder="Aramak istediğinizi yazın..."
//                         value={query}
//                         onChange={handleInputChange}
//                     />
//                     {query && (
//                         <button
//                             onClick={handleClear}
//                             className="text-gray-400 hover:text-gray-600 transition-colors"
//                         >
//                             <FiX className="text-xl" />
//                         </button>
//                     )}
//                     <button
//                         onClick={onClose}
//                         className="text-gray-400 hover:text-gray-600 transition-colors"
//                     >
//                         <FiX className="text-2xl" />
//                     </button>
//                 </div>

//                 {/* Results Container */}
//                 <div className="max-h-[60vh] overflow-y-auto">
//                     {/* Loading State */}
//                     {isLoading && (
//                         <div className="flex items-center justify-center py-12">
//                             <div className="flex flex-col items-center gap-3">
//                                 <div className="w-8 h-8 border-4 border-blue-500 border-t-transparent rounded-full animate-spin" />
//                                 <p className="text-gray-500 text-sm">Aranıyor...</p>
//                             </div>
//                         </div>
//                     )}

//                     {/* Error State */}
//                     {error && !isLoading && (
//                         <div className="p-8 text-center">
//                             <p className="text-red-500">{error}</p>
//                         </div>
//                     )}

//                     {/* Empty State */}
//                     {!isLoading && !error && query.trim().length > 0 && results.length === 0 && (
//                         <div className="p-8 text-center">
//                             <FiSearch className="mx-auto text-gray-300 text-4xl mb-3" />
//                             <p className="text-gray-500">
//                                 "<span className="font-medium">{query}</span>" için sonuç bulunamadı.
//                             </p>
//                         </div>
//                     )}

//                     {/* Results List */}
//                     {!isLoading && !error && results.length > 0 && (
//                         <div className="p-2">
//                             {results.map((item) => (
//                                 <a
//                                     key={item.id}
//                                     href={item.url}
//                                     className="block p-4 rounded-lg hover:bg-gray-50 transition-colors group"
//                                     onClick={onClose}
//                                 >
//                                     <div className="flex items-start gap-3">
//                                         <div className="mt-1 text-gray-400 group-hover:text-blue-500 transition-colors">
//                                             {item.type === "Post" ? (
//                                                 <FiFileText className="text-xl" />
//                                             ) : (
//                                                 <FiFile className="text-xl" />
//                                             )}
//                                         </div>
//                                         <div className="flex-1 min-w-0">
//                                             <div className="flex items-center gap-2 mb-1">
//                                                 <h3 className="font-medium text-gray-900 group-hover:text-blue-600 transition-colors truncate">
//                                                     {item.title}
//                                                 </h3>
//                                                 <span className="flex-shrink-0 text-xs px-2 py-1 bg-blue-50 text-blue-700 rounded-full font-medium">
//                                                     {item.type === "Post" ? "Haber" : "Yayın"}
//                                                 </span>
//                                             </div>
//                                             {item.description && (
//                                                 <p className="text-sm text-gray-600 line-clamp-2">
//                                                     <ReactMarkdown>{item.description}</ReactMarkdown>
//                                                 </p>
//                                             )}
//                                         </div>
//                                     </div>
//                                 </a>
//                             ))}
//                         </div>
//                     )}

//                     {/* Initial State - Search Tips */}
//                     {!isLoading && !error && query.trim().length === 0 && (
//                         <div className="p-8 text-center">
//                             <FiSearch className="mx-auto text-gray-300 text-4xl mb-3" />
//                             <p className="text-gray-500 mb-2">Aramaya başlamak için yazmaya başlayın</p>
//                             <p className="text-sm text-gray-400">Haberler ve yayınlar arasında arama yapabilirsiniz</p>
//                         </div>
//                     )}
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default SearchOverlay;



// import React, { useEffect, useRef, useState, useCallback } from "react";
// import { FiSearch, FiX, FiFile, FiFileText } from "react-icons/fi";
// import ReactMarkdown from "react-markdown";
// import { STRAPI_URL } from "../../../config/constants";

// const normalizeForCompare = (str = "") => {
//     return str
//         .toLowerCase()
//         .normalize("NFKD")
//         .replace(/[\u0300-\u036f]/g, "")     // remove diacritics
//         .replace(/[’'`´]/g, "")              // all apostrophes
//         .replace(/ç/g, "c")
//         .replace(/ğ/g, "g")
//         .replace(/ı/g, "i")
//         .replace(/ö/g, "o")
//         .replace(/ş/g, "s")
//         .replace(/ü/g, "u")
//         .replace(/[^a-z0-9\s]/gi, "")        // strip all punctuation
//         .replace(/\s+/g, " ")
//         .trim();
// };


// const normalizeItem = (item, type, basePath) => {
//     if (!item) return null;
//     const attrs = item.attributes || item;

//     const title = attrs.title || attrs.heading || attrs.name || "Başlıksız";
//     const description = attrs.description || attrs.excerpt || attrs.summary || "";
//     const slug = attrs.slug || item.id;

//     return {
//         id: `${type}-${item.id}`,
//         title,
//         description,
//         type,
//         url: `${basePath}/${slug}`,
//     };
// };

// const SearchOverlay = ({ isOpen, onClose }) => {
//     const [query, setQuery] = useState("");
//     const [results, setResults] = useState([]);
//     const [isLoading, setIsLoading] = useState(false);
//     const [error, setError] = useState(null);

//     const inputRef = useRef(null);
//     const debounceRef = useRef(null);

//     useEffect(() => {
//         if (isOpen && inputRef.current) {
//             setTimeout(() => inputRef.current.focus(), 80);
//         }
//     }, [isOpen]);

//     useEffect(() => {
//         if (!isOpen) {
//             setQuery("");
//             setResults([]);
//             setError(null);
//         }
//     }, [isOpen]);

//     useEffect(() => {
//         if (!isOpen) return;
//         const onKey = (e) => {
//             if (e.key === "Escape") onClose();
//         };
//         window.addEventListener("keydown", onKey);
//         return () => window.removeEventListener("keydown", onKey);
//     }, [isOpen, onClose]);

//     const buildStrapiUrl = (collection, qOriginal, qNormalized, limit = 10) => {
//         const base = STRAPI_URL || "http://localhost:1337";
//         const o = encodeURIComponent(qOriginal);
//         const n = encodeURIComponent(qNormalized);

//         // We send multiple OR filters to increase the chance Strapi matches (some DBs are accent-sensitive)
//         return (
//             `${base}/api/${collection}?` +
//             `?fields=id,slug,documentId,title,createdAt,updatedAt,publishedAt` +
//             `filters[$or][0][title][$containsi]=${o}&filters[$or][1][description][$containsi]=${o}` +
//             `&filters[$or][2][title][$containsi]=${n}&filters[$or][3][description][$containsi]=${n}` +
//             `&pagination[limit]=${limit}&populate=*`
//         );
//     };

//     const clientSideFilter = (items, qNorm) => {
//         if (!qNorm) return [];
//         return (items || []).filter((it) => {
//             const t = normalizeForCompare(it.title);
//             const d = normalizeForCompare(it.description || "");
//             return t.includes(qNorm) || d.includes(qNorm);
//         });
//     };

//     const fetchResults = useCallback(async (text) => {
//         const raw = (text || "").trim();
//         if (raw.length < 2) {
//             setResults([]);
//             return;
//         }

//         setIsLoading(true);
//         setError(null);

//         try {
//             const qOriginal = raw;
//             const qNormalized = normalizeForCompare(raw);

//             // 1) Try "normal" filtered search (fast, minimal data)
//             const postsUrl = buildStrapiUrl("posts", qOriginal, qNormalized, 10);
//             const pubsUrl = buildStrapiUrl("publications", qOriginal, qNormalized, 10);

//             const [postsRes, pubsRes] = await Promise.all([fetch(postsUrl), fetch(pubsUrl)]);
//             if (!postsRes.ok || !pubsRes.ok) throw new Error("Strapi request failed");

//             const postsJson = await postsRes.json();
//             const pubsJson = await pubsRes.json();

//             let posts = (postsJson.data || []).map((it) => normalizeItem(it, "Post", "/basin/haberler"));
//             let pubs = (pubsJson.data || []).map((it) => normalizeItem(it, "Publication", "/basin/yayinlar"));

//             let combined = [...posts, ...pubs].slice(0, 10);

//             // 2) If Strapi returns nothing (common when accents/apostrophes mismatch),
//             //    do a slightly broader fetch and filter on the client (guaranteed match behavior).
//             if (combined.length === 0) {
//                 const postsWide = buildStrapiUrl("posts", qOriginal, qNormalized, 50);
//                 const pubsWide = buildStrapiUrl("publications", qOriginal, qNormalized, 50);

//                 const [pWideRes, puWideRes] = await Promise.all([fetch(postsWide), fetch(pubsWide)]);
//                 if (pWideRes.ok && puWideRes.ok) {
//                     const pWide = await pWideRes.json();
//                     const puWide = await puWideRes.json();

//                     posts = (pWide.data || []).map((it) => normalizeItem(it, "Post", "/basin/haberler"));
//                     pubs = (puWide.data || []).map((it) => normalizeItem(it, "Publication", "/basin/yayinlar"));

//                     const qNorm = normalizeForCompare(raw);
//                     combined = [...clientSideFilter(posts, qNorm), ...clientSideFilter(pubs, qNorm)].slice(0, 10);
//                 }
//             }

//             setResults(combined);
//         } catch (e) {
//             setError("Arama sırasında bir hata oluştu. Lütfen tekrar deneyin.");
//             setResults([]);
//         } finally {
//             setIsLoading(false);
//         }
//     }, []);

//     const onChange = (e) => {
//         const v = e.target.value;
//         setQuery(v);

//         if (debounceRef.current) clearTimeout(debounceRef.current);
//         debounceRef.current = setTimeout(() => fetchResults(v), 300);
//     };

//     const clear = () => {
//         setQuery("");
//         setResults([]);
//         setError(null);
//         inputRef.current?.focus();
//     };

//     if (!isOpen) return null;

//     return (
//         <div
//             className="fixed inset-0 z-[9999] bg-black/55 backdrop-blur-sm flex items-end md:items-start justify-center"
//             onClick={onClose}
//         >
//             <div
//                 className="
//           w-full md:max-w-2xl md:mt-[10vh]
//           bg-white rounded-t-3xl md:rounded-xl shadow-2xl
//           overflow-hidden
//           max-h-[92vh] md:max-h-[80vh]
//           flex flex-col
//           transition-transform duration-200
//         "
//                 onClick={(e) => e.stopPropagation()}
//             >
//                 {/* Header */}
//                 <div className="flex items-center gap-3 p-4 border-b border-gray-200">
//                     <FiSearch className="text-gray-400 text-xl" />
//                     <input
//                         ref={inputRef}
//                         value={query}
//                         onChange={onChange}
//                         placeholder="Aramak istediğinizi yazın..."
//                         className="flex-1 bg-transparent outline-none text-lg placeholder:text-gray-400"
//                         inputMode="search"
//                         autoComplete="off"
//                     />
//                     {query && (
//                         <button onClick={clear} className="text-gray-400 hover:text-gray-600">
//                             <FiX className="text-xl" />
//                         </button>
//                     )}
//                     <button onClick={onClose} className="text-gray-400 hover:text-gray-600">
//                         <FiX className="text-2xl" />
//                     </button>
//                 </div>

//                 {/* Body */}
//                 <div className="flex-1 overflow-y-auto">
//                     {isLoading && (
//                         <div className="flex items-center justify-center py-10">
//                             <div className="flex flex-col items-center gap-3">
//                                 <div className="w-8 h-8 border-4 border-blue-500 border-t-transparent rounded-full animate-spin" />
//                                 <p className="text-gray-500 text-sm">Aranıyor...</p>
//                             </div>
//                         </div>
//                     )}

//                     {!isLoading && error && <div className="p-8 text-center text-red-500">{error}</div>}

//                     {!isLoading && !error && query.trim().length > 0 && results.length === 0 && (
//                         <div className="p-8 text-center text-gray-500">
//                             “<span className="font-medium">{query}</span>” için sonuç bulunamadı.
//                         </div>
//                     )}

//                     {!isLoading && !error && results.length > 0 && (
//                         <div className="flex-1 overflow-y-auto max-h-[70vh] md:max-h-[60vh] px-2 pb-4">
//                             {results.map((item) => (
//                                 <a
//                                     key={item.id}
//                                     href={item.url}
//                                     onClick={onClose}
//                                     className="block p-4 rounded-lg hover:bg-gray-50 transition-colors"
//                                 >
//                                     <div className="flex items-start gap-3">
//                                         <div className="mt-1 text-gray-400">
//                                             {item.type === "Post" ? <FiFileText className="text-xl" /> : <FiFile className="text-xl" />}
//                                         </div>
//                                         <div className="flex-1 min-w-0">
//                                             <div className="flex items-center gap-2 mb-1">
//                                                 <h3 className="font-medium text-gray-900 truncate">{item.title}</h3>
//                                                 <span className="text-xs px-2 py-1 bg-blue-50 text-blue-700 rounded-full font-medium">
//                                                     {item.type === "Post" ? "Haber" : "Yayın"}
//                                                 </span>
//                                             </div>
//                                             {item.description && (
//                                                 <p className="text-sm text-gray-600 line-clamp-2">
//                                                     <ReactMarkdown>{item.description}</ReactMarkdown>
//                                                 </p>
//                                             )}
//                                         </div>
//                                     </div>
//                                 </a>
//                             ))}
//                         </div>
//                     )}

//                     {!isLoading && !error && query.trim().length === 0 && (
//                         <div className="p-8 text-center text-gray-500">
//                             Aramaya başlamak için yazmaya başlayın
//                         </div>
//                     )}
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default SearchOverlay;



import React, { useEffect, useRef, useState, useCallback } from "react";
import { FiSearch, FiX, FiFileText, FiFile } from "react-icons/fi";
import Fuse from "fuse.js";
import { STRAPI_URL } from '../../../config/constants'

const normalizeItem = (item, type, basePath) => {
    if (!item) return null;
    const attrs = item.attributes || item;

    const title = attrs.title || attrs.heading || attrs.name || "Başlıksız";
    const desc = attrs.description || attrs.excerpt || attrs.summary || "";
    const slug = attrs.slug || item.id;

    return {
        id: `${type}-${item.id}`,
        title,
        description: desc.replace(/[#_*>\[\]\(\)`]/g, ""),
        type,
        url: `${basePath}/${slug}`,
    };
};

const SearchOverlay = ({ isOpen, onClose }) => {
    const [query, setQuery] = useState("");
    const [results, setResults] = useState([]);
    const [searchData, setSearchData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const fuseRef = useRef(null);
    const inputRef = useRef(null);
    const debounceRef = useRef(null);

    // Focus input
    useEffect(() => {
        if (isOpen) {
            setTimeout(() => inputRef.current?.focus(), 120);
        }
    }, [isOpen]);

    useEffect(() => {
        if (!isOpen) {
            setQuery("");
            setResults([]);
        }
    }, [isOpen]);

    // Escape closes
    useEffect(() => {
        if (!isOpen) return;
        const handler = (e) => e.key === "Escape" && onClose();
        window.addEventListener("keydown", handler);
        return () => window.removeEventListener("keydown", handler);
    }, [isOpen, onClose]);

    // Fetch data once
    useEffect(() => {
        if (!isOpen || searchData.length > 0) return;
        fetchData();
    }, [isOpen]);

    // Init fuse
    useEffect(() => {
        if (searchData.length > 0) {
            fuseRef.current = new Fuse(searchData, {
                keys: [
                    { name: "title", weight: 2 },
                    { name: "description", weight: 1 },
                ],
                threshold: 0.3,
                ignoreLocation: true,
                minMatchCharLength: 2,
            });
        }
    }, [searchData]);

    const fetchData = async () => {
        try {
            setLoading(true);
            const base = STRAPI_URL || "http://localhost:1337";

            const urls = {
                posts: `${base}/api/posts?fields=id,slug,title,description&pagination[limit]=100`,
                pubs: `${base}/api/publications?fields=id,slug,title,description&pagination[limit]=100`,
            };

            const [postsRes, pubsRes] = await Promise.all([
                fetch(urls.posts),
                fetch(urls.pubs),
            ]);

            if (!postsRes.ok || !pubsRes.ok) throw new Error();

            const postsJson = await postsRes.json();
            const pubsJson = await pubsRes.json();

            const posts = postsJson.data.map((it) =>
                normalizeItem(it, "Post", "/basin/haberler")
            );

            const pubs = pubsJson.data.map((it) =>
                normalizeItem(it, "Publication", "/basin/yayinlar")
            );

            setSearchData([...posts, ...pubs]);
        } catch {
            setError("Veri yüklenirken bir hata oluştu.");
        } finally {
            setLoading(false);
        }
    };

    const performSearch = useCallback((text) => {
        const q = text.trim();
        if (!q || q.length < 2 || !fuseRef.current) {
            setResults([]);
            return;
        }
        const res = fuseRef.current.search(q).slice(0, 12).map((r) => r.item);
        setResults(res);
    }, []);

    const onChange = (e) => {
        const v = e.target.value;
        setQuery(v);

        if (debounceRef.current) clearTimeout(debounceRef.current);
        debounceRef.current = setTimeout(() => performSearch(v), 250);
    };

    const clearQuery = () => {
        setQuery("");
        setResults([]);
        inputRef.current?.focus();
    };

    if (!isOpen) return null;

    return (
        <div
            className="fixed inset-0 z-[9999] bg-black/50 backdrop-blur-sm flex justify-center md:items-start items-end md:pt-16"
            onClick={onClose}
        >
            <div
                className="relative w-full md:max-w-2xl bg-white rounded-t-3xl md:rounded-xl shadow-xl md:max-h-[calc(100vh-8rem)] max-h-[92vh] overflow-hidden flex flex-col animate-slide-up"
                onClick={(e) => e.stopPropagation()}
            >

                {/* ---------------- DESKTOP SEARCH BAR (top) ---------------- */}
                <div className="hidden md:flex items-center gap-3 p-4 border-b border-gray-200 flex-shrink-0">
                    <FiSearch className="text-gray-400 text-xl" />
                    <input
                        ref={inputRef}
                        value={query}
                        onChange={onChange}
                        placeholder="Aramak istediğinizi yazın..."
                        className="flex-1 bg-transparent outline-none text-lg"
                    />
                    {query && (
                        <button onClick={clearQuery} className="text-gray-400 hover:text-gray-600">
                            <FiX className="text-xl" />
                        </button>
                    )}
                    <button onClick={onClose} className="text-gray-400 hover:text-gray-600">
                        <FiX className="text-2xl" />
                    </button>
                </div>

                {/* ---------------- RESULTS ---------------- */}
                <div className="flex-1 overflow-y-auto md:pb-0 pb-[72px]">
                    {loading && (
                        <div className="flex items-center justify-center py-10">
                            <div className="w-8 h-8 border-4 border-blue-500 border-t-transparent rounded-full animate-spin" />
                        </div>
                    )}

                    {!loading && error && (
                        <div className="text-center text-red-500 p-6">{error}</div>
                    )}

                    {!loading && !error && query && results.length === 0 && (
                        <div className="p-8 text-center text-gray-500">Sonuç bulunamadı</div>
                    )}

                    {!loading && results.length > 0 && (
                        <div className="px-2 pb-4">
                            {results.map((item) => (
                                <a
                                    key={item.id}
                                    href={item.url}
                                    onClick={onClose}
                                    className="flex gap-3 p-4 rounded-lg hover:bg-gray-50 transition-colors"
                                >
                                    <div className="text-gray-400 mt-1">
                                        {item.type === "Post" ? (
                                            <FiFileText className="text-xl" />
                                        ) : (
                                            <FiFile className="text-xl" />
                                        )}
                                    </div>

                                    <div className="flex-1 min-w-0">
                                        <div className="flex items-center gap-2">
                                            <h3 className="font-medium text-gray-900 truncate">
                                                {item.title}
                                            </h3>
                                            <span className="text-xs px-2 py-1 bg-blue-50 text-blue-700 rounded-full">
                                                {item.type === "Post" ? "Haber" : "Yayın"}
                                            </span>
                                        </div>
                                        {item.description && (
                                            <p className="text-sm text-gray-600 line-clamp-2">
                                                {item.description}
                                            </p>
                                        )}
                                    </div>
                                </a>
                            ))}
                        </div>
                    )}

                    {!loading && !error && !query && (
                        <div className="text-center text-gray-400 p-10">
                            Aramaya başlamak için yazın
                        </div>
                    )}
                </div>

                {/* ---------------- MOBILE SEARCH BAR (fixed bottom) ---------------- */}
                <div className="md:hidden fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 p-4 flex items-center gap-3 z-[10000] flex-shrink-0">
                    <FiSearch className="text-gray-400 text-xl" />
                    <input
                        ref={inputRef}
                        value={query}
                        onChange={onChange}
                        placeholder="Aramak istediğinizi yazın..."
                        className="flex-1 outline-none text-lg bg-transparent"
                    />
                    {query && (
                        <button onClick={clearQuery} className="text-gray-400 hover:text-gray-600">
                            <FiX className="text-xl" />
                        </button>
                    )}
                    <button onClick={onClose} className="text-gray-400 hover:text-gray-600">
                        <FiX className="text-2xl" />
                    </button>
                </div>
            </div>
        </div>
    );
};

export default SearchOverlay;